// This are the Filter component in the filters sidebar
import { Fragment } from 'react';
import { searchToolGroceriesFilters as groceriesFilters } from '../../customize/const';
// import { DIETARY_REMOVAL_MAP as drm } from '../../constants/constants';
import Selector from '../../generic/Selector';
import { connect } from 'react-redux';
import {
  toggleSkuFilter,
  clearSkuFilters,
  applySkuFilters,
  getFilteredSkus,
  getCategories,
} from '../../customize/actions_creators';
import HorizontalLine from '../../generic/HorizontalLine';

const GroceriesFilters = ({
  selectedFilters,
  toggleFilter,
  clearFilters,
  applyFilters,
  refreshSkus,
  dietaryPreferences,
  tagOptions,
  tagOptionsOrder,
}) => {
  const { featured, dietary, protein, spicy_level } = groceriesFilters;

  // Using dietary preferences filter the dietary filters Options:
  let filteredDietaryOptions = Object.keys(dietary.options).reduce(
    (acc, key) => {
      if (!dietaryPreferences[key]) acc[key] = dietary.options[key];
      return acc;
    },
    {}
  );

  const clearAndGet = () => {
    clearFilters();
    refreshSkus();
  };

  const applyAndGet = () => {
    applyFilters();
    refreshSkus();
  };

  return (
    <div className="filters-container">
      <div className="hr-subtitle-md-bold hr-mb-16">{featured.title}</div>
      <Selector
        options={featured.options}
        action={(val) => toggleFilter(val, 'featured')}
        type="checkbox"
        selected={selectedFilters.featured}
      />
      <HorizontalLine />
      <div className="hr-subtitle-md-bold hr-mb-16">{protein.title}</div>
      <Selector
        options={tagOptions}
        action={(val) => toggleFilter(val, 'protein')}
        type="checkbox"
        selected={selectedFilters.protein}
        optionsOrder={tagOptionsOrder}
      />
      <HorizontalLine />
      <div className="hr-subtitle-md-bold hr-mb-16">{spicy_level.title}</div>
      <Selector
        options={spicy_level.options}
        action={(val) => toggleFilter(val, 'spicy_level')}
        type="checkbox"
        selected={selectedFilters.spicy_level}
      />
      <HorizontalLine />
      {Object.keys(filteredDietaryOptions).length ? (
        <Fragment>
          <div className="hr-subtitle-md-bold hr-mb-16">{dietary.title}</div>
          <Selector
            options={filteredDietaryOptions}
            action={(val) => toggleFilter(val, 'dietary')}
            type="checkbox"
            selected={selectedFilters.dietary}
          />
          <HorizontalLine />
        </Fragment>
      ) : null}
      <div className="placeholder-element"></div>
      <div className="filter-btns">
        <button onClick={clearAndGet} className="hr-btn-hol">
          Clear
        </button>
        <button onClick={applyAndGet} className="hr-btn-blue">
          Apply
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    selectedFilters: state.filters.selectedSkuFilters,
    dietaryPreferences: state.filters.dietaryPreferences,
    skusList: state.filters.skus,
    categories: state.featured.categories,
    tagOptions: state.filters.tagOptions,
    tagOptionsOrder: state.filters.tagOptionsOrder,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    toggleFilter: (f, fc) => dispatch(toggleSkuFilter(f, fc)),
    clearFilters: () => dispatch(clearSkuFilters()),
    applyFilters: () => dispatch(applySkuFilters()),
    refreshSkus: () => dispatch(getFilteredSkus()),
    getCategories: () => dispatch(getCategories()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GroceriesFilters);
